const material = [
	"Keramik",
	"Baukeramik",
	"Rotlehm",
	"Metall unbestimmt",
	"Gold",
	"Silber",
	"Eisen",
	"Kupferlegierung/Bronze",
	"Blei",
	"Glas",
	"Schlacke",
	"Bernstein",
	"Gagat",
	"Stein",
	"Silex",
	"Knochen",
	"Tierknochen",
	"Knochenbrand",
	"Geweih",
	"Pech",
	"Holz",
	"Holzkohle",
	"Leder",
	"Textil",
	"unbest. organisches Material",
	"Moertel",
	"Ziegel",
	"Muenze",
	"Perle",
	"Steingeraet",
	"Geweih",
	"Kaustobiolithe",
	"Elfenbein",
	"Bein",
	"Fibel"
];

export default material;
